import React, { Fragment, useEffect, useState } from "react";
import { Card, CardBody, CardFooter, Col, Row } from "reactstrap";
import PageHeading from "Layout/AppMain/PageHeading";
import Table from "./Table";
import { DropdownList } from "react-widgets/cjs";
import { debounce } from "helperFunctions";
import TransitionOnLoad from "Components/TransitionOnLoad";
import { useSearchBestuur, useCommunities, useContracts } from "Api/Admin/Anonimiseren";


const Anonimiseren = () => {
    const [communityId, setCommunityId] = useState('');
    const [searchCommunityLists, setSearchCommunityLists] = useState([]);
    const [pageSizeCount, setPageSizeCount] = useState(20);
    const [pageNumber, setPageNumber] = useState(1);
    const [anonymize, setAnonymize] = useState(null);
    const [search, setSearch] = useState('')
    const { trigger: searchBestuur } = useSearchBestuur();

    const {
        data: communityResponse,
        isLoading: communityLoading,
    } = useCommunities();

    const communityList = [
        { value: "all", label: "Alle bestuur" },
        ...(communityResponse?.data?.communitiesLists?.map((item) => ({
            value: item.iCommunityId,
            label: item.vCommunityName,
        })) || []),
    ];

    useEffect(() => {
        if (communityList.length && !communityId) {
            setCommunityId("all");
        }
    }, [communityList]);

    const params = new URLSearchParams();
    params.append("iCommunityId", communityId);
    params.append("pageSize", pageSizeCount);
    params.append("page", pageNumber);

    if (anonymize !== null && anonymize !== undefined) {
        params.append("anonymize", anonymize);
    }

    const {
        data: anonymizeResponse,
        isLoading: anonymizeLoading,
        mutate,
    } = useContracts(
        communityId,
        pageSizeCount,
        pageNumber,
        anonymize,
        search
    );

    const anonymizeLists =
        anonymizeResponse?.data?.lists || [];

    const totalPageCount =
        anonymizeResponse?.data?.pageCount || 0;
    const count = anonymizeResponse?.data?.totalCount;

    const showLoader =
        communityLoading || anonymizeLoading;

    const handleCommunityChange = (selectedValue) => {
        setCommunityId(selectedValue);
    };

    const fetchCommunityList = async (searchTerm) => {
        const isMatchedInCommunityList = (searchTerm) => {
            return communityList?.some((item) => {
                const labelMatch = item.label
                    ?.toLowerCase()
                    .includes(searchTerm.toLowerCase());

                const valueMatch = String(item.value)
                    ?.toLowerCase()
                    .includes(searchTerm.toLowerCase());

                return labelMatch || valueMatch;
            });
        };

        if (searchTerm !== "") {
            if (!isMatchedInCommunityList(searchTerm)) {
                try {
                    const response = await searchBestuur({
                        data: {
                            search: searchTerm,
                        },
                    });

                    if (response?.data?.status) {
                        setSearchCommunityLists(
                            response.data.data.communitiesLists.map((item) => ({
                                value: item.iCommunityId,
                                label: item.vCommunityName,
                            }))
                        );
                    }
                } catch (error) {
                    console.error(error);
                }
            }
        } else {
            setSearchCommunityLists([]);
        }
    };

    const debounceSearchCommunity = debounce(fetchCommunityList, 500);

    const fetchCommunitySearch = (searchTerm) => {
        debounceSearchCommunity(searchTerm)
    }

    return (
        <Fragment>
            <PageHeading />
            <TransitionOnLoad>
                <div>
                    <Row>
                        <Col md="12">
                            <Card className="main-card mb-3" >
                                <CardBody className="p-3">
                                    <Table showLoader={showLoader} setSearch={setSearch} anonymizeLists={anonymizeLists} mutate={mutate} setPageSizeCount={setPageSizeCount} pageSizeCount={pageSizeCount} setPageNumber={setPageNumber} pageNumber={pageNumber} totalPageCount={totalPageCount} count={count} />
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </div>
            </TransitionOnLoad>
            <div className="chat-layout-footer verzoken-footer-height"><CardFooter className="chat-layout-footer__inner"><div className="d-flex gap-3 mr-4">
                <div className="footer-field-min-width">
                    <DropdownList
                        dataKey="value"
                        textField="label"
                        placeholder="Selecteer"
                        onChange={(e) => handleCommunityChange(e.value)}
                        name="communityIds"
                        value={communityId}
                        data={searchCommunityLists?.length > 0 ? searchCommunityLists : communityList}
                        onSearch={(searchTerm) => fetchCommunitySearch(searchTerm)}
                        dropUp
                        onBlur={() => setSearchCommunityLists([])}
                        filter={(item, searchTerm) => {
                            const labelMatch = item.label?.toLowerCase().includes(searchTerm.toLowerCase());
                            const valueMatch = String(item.value)?.toLowerCase().includes(searchTerm.toLowerCase());
                            return labelMatch || valueMatch;
                        }}
                    />
                </div>
                <div className="footer-field-min-width">
                    <DropdownList
                        dataKey="value"
                        textField="label"
                         dropUp
                        placeholder="Selecteer"
                        name="anonymize"
                        value={anonymize}
                        data={[
                            { value: -1, label: "Alle" },
                            { value: 0, label: "Anonimiseren" },
                            { value: 1, label: "Niet anonimiseren" }
                        ]}
                        onChange={(e) => {
                            if (e.value === -1) {
                                setAnonymize(null);
                                return;
                            }

                            setAnonymize(e.value);
                        }}
                    />
                </div>
            </div></CardFooter>
            </div>
        </Fragment>
    )
};

export default Anonimiseren;
